import React, { Fragment } from 'react';
import DataTable from 'components/DataTable/DataTable';
import { Document, MenuOption } from 'dataTypes/document';
import { dateToString } from 'utils/formatDate';
import { Grid, Typography } from '@mui/material';
import styles from './DocumentTable.module.css';
import MenuButton from 'components/MenuButton/MenuButton';
import { MoreHorizOutlined } from '@mui/icons-material';
import { formatTextUpperCase } from 'utils/formatName';

interface DocumentTableProps {
  data: Document[];
  menuItems?: (id: number, name: string, status: string, type: string) => MenuOption[];
}
const DocumentTable: React.FC<DocumentTableProps> = ({ data, menuItems }) => {
  const rowsData = data.map(({ id, name, status, createdAt, statusUpdated, type }) => {
    return {
      name: <Typography color={'#315A8A'}>{name}</Typography>,
      status: status && formatTextUpperCase(status),
      createdAt: dateToString(createdAt),
      statusUpdated: dateToString(statusUpdated),
      more: (
        <MenuButton options={menuItems!(id, name, status, type)} tooltipLabel='More Options'>
          <MoreHorizOutlined />
        </MenuButton>
      ),
    };
  });

  return (
    <Fragment>
      <Grid container className={styles.container}>
        <Grid item xs={12}>
          <DataTable
            columnData={[
              {
                id: 'name',
                name: 'File Name',
                align: 'left',
                enableSort: true,
              },
              { id: 'status', name: 'Status', align: 'left' },
              {
                id: 'createdAt',
                name: 'Created Date',
                align: 'left',
                enableSort: true,
              },
              {
                id: 'statusUpdated',
                name: 'Last Change',
                align: 'left',
                enableSort: true,
              },
              {
                id: 'more',
                name: 'More',
                align: 'left',
              },
            ]}
            rows={rowsData}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default DocumentTable;
